const VALUE_PILL_ROW_PX = 20;
const VALUE_PILL_ROW_GAP_PX = 4;
const OPTION_ROW_HEIGHT_PX = 44;
const MENU_GAP_PX = 4;
const MENU_VERTICAL_PADDING_PX = 8;

export function getValuePillsRowMaxStyle(maxRows) {
  const n = Math.max(1, Number(maxRows) || 1);
  return {
    maxHeight: `${n * VALUE_PILL_ROW_PX + Math.max(0, n - 1) * VALUE_PILL_ROW_GAP_PX}px`,
  };
}

export function getMultiSelectMenuMaxHeightPx(maxRows) {
  const n = Math.max(1, Math.floor(Number(maxRows)));
  return n * OPTION_ROW_HEIGHT_PX + Math.max(0, n - 1) * MENU_GAP_PX + MENU_VERTICAL_PADDING_PX;
}

export function getMenuScrollLayout(maxMenuRows, optionCount) {
  const n = typeof optionCount === 'number' ? optionCount : 0;
  const needsMenuScroll = typeof maxMenuRows === 'number' && maxMenuRows > 0 && n > maxMenuRows;
  const menuMaxHeightPx = needsMenuScroll ? getMultiSelectMenuMaxHeightPx(maxMenuRows) : undefined;
  return { needsMenuScroll, menuMaxHeightPx };
}

export function getFixedMenuWidthStyle(menuWidthPx) {
  if (typeof menuWidthPx !== 'number' || menuWidthPx <= 0) return null;
  return {
    width: `${menuWidthPx}px`,
    minWidth: `${menuWidthPx}px`,
    maxWidth: `${menuWidthPx}px`,
    boxSizing: 'border-box',
  };
}
